import React from "react";

import { Slot } from "~/components/slot";

import { enable, useIsEnabled } from "./_enabler";

const LazyTrigger = React.lazy(async () => {
	// biome-ignore lint/style/noRestrictedImports: component usage
	const { Trigger } = await import("@radix-ui/react-dropdown-menu");

	return { default: Trigger };
});

export type DropdownMenuTriggerProps = React.ComponentProps<typeof LazyTrigger>;

export const DropdownMenuTrigger = React.forwardRef<React.ComponentRef<typeof LazyTrigger>, DropdownMenuTriggerProps>(
	({ asChild = true, ...props }, ref) => {
		const Root = asChild ? Slot : "button";
		const isEnabled = useIsEnabled();

		if (isEnabled) {
			return (
				<React.Suspense fallback={<Root ref={ref} {...props} />}>
					<LazyTrigger asChild={asChild} ref={ref} {...props} />
				</React.Suspense>
			);
		}

		return (
			<Root
				ref={ref}
				{...props}
				onFocus={(event) => {
					enable();
					props.onFocus?.(event);
				}}
				onMouseEnter={(event) => {
					enable();
					props.onMouseEnter?.(event);
				}}
			/>
		);
	},
);

if (import.meta.env.DEV) {
	DropdownMenuTrigger.displayName = "DropdownMenuTrigger";
}
